/**
 * Storage keys — kept identical to process-runner so the cookie/session
 * semantics stay compatible with the same backend. Anything that needs
 * to survive a hard refresh lives in localStorage; transient
 * coordination (refresh-token lock) lives in sessionStorage.
 */

export const LS_KEYS = {
  expireAt: 'expireAt',
  accountName: 'accountName',
  companyName: 'companyName',
  tenantId: 'tenantId',
  tenantExternalName: 'tenantExternalName',
  email: 'email',
  logo: 'logo',
  logoBackgroundColor: 'logoBackgroundColor',
  additionalLogos: 'additionalLogos',
  additionalLogoBackgroundColor: 'additionalLogoBackgroundColor',
  signinJumperUrlPath: 'signinJumperUrlPath',
  idleTimeoutMins: 'itms',
  logoutUrl: 'logoutUrl',
  userPicture: 'user_picture',
  userDetails: 'userDetails',
  /** JWT from login/refresh when host-scoped cookies are unavailable. */
  idToken: 'idToken',
  refreshToken: 'refreshToken',
  // SSO client config (loginSettings response)
  authType: 'authType',
  clientId: 'clientId',
  connection: 'connection',
  authUrl: 'authUrl',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  ssoHistory: 'ssoHistory',
} as const

export const SS_KEYS = {
  refreshTokenLock: 'oro-mobile-refresh-token-lock',
} as const
